import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormFieldWithLabel as FormField, FormFieldWrapper as FormFieldsWrapper } from 'views/FormComponents';
import { getCookie } from 'config/utils';
import decorateSocialPay from '../decorators/SocialPay';
import scrollController from '../decorators/ScrollController';
import StatefulSubmitButton from 'views/StatefulSubmitButton';
import CustomFields from './refine/customFields';

import {
  handleChangeInput,
  handleSubmitRefinePurchase,
  handleSetSocialPayPlatformAndSubmitForm,
} from '../actions/RefinePurchaseActions';

import {
  handleSetupCloseSocialPayAuthWindowBeforeAuthListener,
} from '../actions/SocialPayActions';

class RefinePurchase extends React.Component {
  componentDidUpdate () {
    const { form: { claimUrl, selectedSocialPayPlatform }, isFormServerValidated } = this.props.refinePurchase;
    const { loading } = this.props.socialPay;
    const serverForm = this.serverForm;
    if (isFormServerValidated && claimUrl && serverForm) {
      serverForm.submit();
    }

    if (isFormServerValidated && selectedSocialPayPlatform && !loading[selectedSocialPayPlatform] && serverForm) {
      this.props.submitSocialPay(selectedSocialPayPlatform, serverForm);
      this.props.handleSetupCloseSocialPayAuthWindowBeforeAuthListener(selectedSocialPayPlatform);
    }
  }

  renderSubmitButton () {
    const { offer: { socialpayPlatforms }, totalAmount, totalAmountWithShipping } = this.props.refinePurchase;

    if (!totalAmount && socialpayPlatforms) {
      return this.props.renderSocialPayButtons(this.props.refinePurchase);
    }

    return (
      <FormField>
        <StatefulSubmitButton value={totalAmount || totalAmountWithShipping ? 'Next' : 'Claim for Free'} />
      </FormField>
    );
  }

  renderHiddenServerForm () {
    const {
      form: { claimUrl, socialpayUrl, selectedSocialPayPlatform },
    } = this.props.refinePurchase;

    return (
      <form ref={(ref) => this.serverForm = ref} action={selectedSocialPayPlatform ? socialpayUrl : claimUrl} method="POST">
        <input type="hidden" name="csrfmiddlewaretoken" value={getCookie('csrftoken')} />
      </form>
    );
  }

  render () {
    const {
      form,
      offer,
      form: {
        claimUrl, socialpayUrl,
      },
      isFormServerValidated,
    } = this.props.refinePurchase;

    return (
      <div>
        <Form onSubmit={e => {
          e.preventDefault();
          this.props.handleSubmitRefinePurchase();
        }}>

          <CustomFields
            form={form}
            offer={offer}
            includeShipping={true}
            onChangeInput={this.props.handleChangeInput}
          />

          <FormFieldsWrapper>
            {this.renderSubmitButton()}
          </FormFieldsWrapper>

        </Form>

        { (socialpayUrl || claimUrl) && isFormServerValidated ?
          this.renderHiddenServerForm() :
          null
        }
      </div>
    );
  }
}


RefinePurchase.propTypes = {
  isOpenable: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

RefinePurchase.defaultProps = {
  isOpenable: true,
  isOpen: false,
  isAnimated: true,
};

function mapStateToProps (state) {
  const { refinePurchase, socialPay, settings: { isMobileDevice } } = state;
  return {
    refinePurchase,
    socialPay,
    isMobileDevice,
  };
}

export default connect(mapStateToProps, {
  handleChangeInput,
  handleSubmitRefinePurchase,
  handleSetSocialPayPlatformAndSubmitForm,
  handleSetupCloseSocialPayAuthWindowBeforeAuthListener,
})(scrollController(decorateSocialPay(RefinePurchase)));



// WEBPACK FOOTER //
// ./src/payments/views/RefinePurchase.js